module.exports = __webpack_public_path__ + "img/googleplay.524dc1e6.png";